// src/NoMobileAccess.js
import React from 'react';

const NoMobileAccess = ({ children }) => {
    const isMobile = () => {
        return /(android|iphone|ipad|mobile|tablet|ipod|opera mini|blackberry|windows phone|iemobile|webos)/i.test(navigator.userAgent || navigator.vendor || window.opera);
    };

    if (isMobile()) {
        return (
            <div style={{ textAlign: 'center', padding: '20px' }}>
                <h1 style={{color:'#00a7ac'}}>Access Restricted</h1>
                <p >Due to security reasons we are restricting the mobile access.So please use the Desktop or Laptop in order to access the website.</p>
            </div>
        );
    }

    return children;
};

export default NoMobileAccess;
